(function () {
  function relocate(productInfo) {
    var bundleNode = productInfo.querySelector('[data-revy-bundle-placement]');
    if (!bundleNode) return;

    var anchor =
      productInfo.querySelector('.shopify-app-block') || productInfo.querySelector('.product-form-wrapper');
    if (!anchor) return;

    var alreadyPlaced =
      bundleNode.parentElement === anchor.parentElement && bundleNode.previousElementSibling === anchor;
    if (!alreadyPlaced) {
      anchor.insertAdjacentElement('afterend', bundleNode);
    }
  }

  function scan() {
    document.querySelectorAll('product-info').forEach(relocate);
  }

  function init() {
    if (!document.querySelector('product-info')) return;

    scan();

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          scan();
          break;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
